import {
  ClaimDetailResponse,
  ClaimEligibilityResponse,
  ClaimListResponse,
  ErrorMessageResponse,
} from '@/types';
import { useSentryQuery, useSentryMutation } from '../utils/sentryQueryWrapper';
import {
  fetchClaimByUid,
  fetchClaimEligibility,
  fetchClaims,
  fileClaim,
} from '@/api/claimService';
import { t } from 'i18next';

// Check whether the merchant can file a claim for a given order
export const useClaimEligibility = (orderUid: string, enabled: boolean = true) => {
  return useSentryQuery<ClaimEligibilityResponse, Error>(
    ['claim-eligibility', orderUid],
    () => fetchClaimEligibility(orderUid),
    {
      enabled: !!orderUid && enabled,
    },
  );
};

// File a new claim for an order (multipart mutation)
export const useFileClaim = () => {
  return useSentryMutation<
    ClaimDetailResponse,
    ErrorMessageResponse,
    { orderUid: string; formData: FormData }
  >(
    ({ orderUid, formData }: { orderUid: string; formData: FormData }) =>
      fileClaim(orderUid, formData),
    { defaultErrorMessage: '' },
  );
};

// Fetch paginated claims list with optional status/type filters
export const useFetchClaims = (
  page: number,
  perPage: number,
  status?: string,
  type?: string,
  enabled: boolean = true,
) => {
  return useSentryQuery<ClaimListResponse, Error>(
    ['claims', page, perPage, status, type],
    () => fetchClaims(page, perPage, status, type),
    {
      keepPreviousData: true,
      enabled,
    },
  );
};

// Fetch a single claim by UID
export const useFetchClaimByUid = (uid: string) => {
  return useSentryQuery<ClaimDetailResponse, Error>(
    ['claim', uid],
    () => fetchClaimByUid(uid),
    {
      enabled: !!uid,
    },
  );
};
